<template>
  <div>
    <img src="@/assets/bicicleta.png" style="width: 100%" />
    <p class="tituloTarjeta">¿USAS BICICLETA?</p>
    <p>
      Con nuestro seguro solo te debe preocupar la ruta. Nosotros nos encargamos del resto:
    </p>
    <ul style="list-style-type: disc">
      <li><span class="strong">Responsabilidad Civil: </span> Si causas un daño a terceros, nosotros respondemos por ti.</li>
      <li><span class="strong">Protección ante Robo: </span> Tu inversión está a salvo, incluso si los amigos de lo ajeno aparecen.</li>
      <li><span class="strong">Daños por Accidente: </span> Si sufres una caída, cubrimos los daños que sufra tu compañera de aventuras.</li>
    </ul>
    <p class="container-flex">
      <a href="https://www.mmtseguros.com/calcular/seguros-movilidad?id_origen=c9772407e7bd0d88fcd118acb7d33c62" target="_blank">
        <button class="pure-button botonLlamar">Calcula tu precio</button>
      </a>
    </p>



  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },


};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
.strong {
  font-weight: 800;
}

</style>
